import { queryClient } from '@capsicum/common';
import { useMutation } from '@tanstack/react-query';

import { surveyApi, surveyKeysFactory } from '../../data-access';

type UsePostSurveyVoteBySurveyIdQueryProps = {
	answerId: string;
	blockchainAddress?: string;
	surveyId: string;
};

export const usePostSurveyVoteBySurveyIdQuery = (partnerId: string, surveyId: string) => {
	return useMutation({
		mutationFn: async ({ answerId, blockchainAddress, surveyId }: UsePostSurveyVoteBySurveyIdQueryProps) =>
			(await surveyApi).postSurveyVoteBySurveyId(surveyId, { answerId, blockchainAddress }),
		mutationKey: ['survey-vote'],
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: surveyKeysFactory.filtered({ partnerIds: [partnerId] }) });
			queryClient.invalidateQueries({ queryKey: ['survey', surveyId] });
			queryClient.invalidateQueries({ queryKey: ['survey', surveyId, 'rewardPointBalance'] });
		}
	});
};
